import { render, staticRenderFns } from "./DiferentsFieldStatus.vue?vue&type=template&id=866b183e"
import script from "./DiferentsFieldStatus.vue?vue&type=script&lang=js"
export * from "./DiferentsFieldStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports